import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { BrandDetailsForm } from './brand-details-form';

import { Brand, brandSchema } from '@shared/types';
import { ViewEditDialog } from '@web/components/ui/view-edit-dialog';

type BrandDetailsCardProps = {
  brand: Brand;
  onSubmit: (data: Brand) => Promise<void>;
  onClose?: () => void;
  defaultEditMode?: boolean;
  newEntityCreation?: boolean;
};

export function BrandDetailsCard({
  brand,
  onSubmit,
  onClose,
  defaultEditMode = false,
  newEntityCreation = false,
}: BrandDetailsCardProps) {
  const form = useForm<Brand>({
    resolver: zodResolver(brandSchema),

    defaultValues: brand,
  });

  return (
    <ViewEditDialog
      title="Brand Details"
      onSubmit={form.handleSubmit(onSubmit)}
      onClose={onClose}
      initEditMode={defaultEditMode}
      newEntityCreation={newEntityCreation}
      render={({ isEditMode, setIsSubmitting }) => (
        <BrandDetailsForm
          form={form}
          isEditMode={isEditMode}
          setIsSubmitting={setIsSubmitting}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose?.();
          }}
        />
      )}
    />
  );
}
